import React from 'react'
import { Switch, Route } from 'react-router-dom'
import Wow from './Wow'
import styles from './index.css'

const Campaign = () => (
  <div className={styles.campaign}>
    <Switch>
      <Route path="/campaign/wow/badges/:type" component={Wow} exact />
    </Switch>
  </div>
)

export default Campaign



// WEBPACK FOOTER //
// ./src/pages/Campaign/index.js